import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-r-small', 'LetterRSmall', [["path",{"d":"M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4"}]]);